import { MaxusDealer } from './MaxusDealer.model';
export default class DealerOverview {
    dealerContainer;
    maxusDealers;
    constructor() {
        this.dealerContainer = document.querySelector('.js-establishment');
        if (!this.dealerContainer)
            return;
        fetch(this.dealerContainer.dataset.maxusdealers)
            .then((response) => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
            .then((data) => {
            this.maxusDealers = data.result.map((maxusDealer) => {
                return new MaxusDealer(maxusDealer.title, maxusDealer.address['street'], maxusDealer.address['houseNumber'], maxusDealer.address['postalCode'], maxusDealer.address['city'], maxusDealer.phoneNumber, maxusDealer.phoneNumberLink, maxusDealer.id, maxusDealer.slug, maxusDealer.services, maxusDealer.websiteUrl);
            });
            this.initDealersOverview();
        })
            .catch((error) => {
            console.error('Error fetching data:', error);
        });
    }
    initDealersOverview() {
        this.maxusDealers.forEach((item) => {
            this.dealerContainer.append(item.renderListView());
        });
    }
    filterByService(values) {
        this.dealerContainer.classList.add('not-visible');
        setTimeout(() => {
            this.dealerContainer.innerHTML = ''; //Clear dealer container
            if (!values[values.length - 1]) {
                if (!this.maxusDealers)
                    return;
                this.maxusDealers.forEach((item) => {
                    this.dealerContainer.append(item.renderListView()); //No value selected, append everything
                });
            }
            else {
                let filteredResults = [];
                if (values == 'sale') {
                    filteredResults = this.maxusDealers.filter((dealer) => {
                        return dealer.salesLocation === true; //Filter sale locations
                    });
                }
                else if (values == 'service') {
                    filteredResults = this.maxusDealers.filter((dealer) => {
                        return dealer.serviceLocation === true; //Filter service locations
                    });
                }
                else {
                    filteredResults = this.maxusDealers.filter((dealer) => {
                        return dealer.salesLocation === true || dealer.serviceLocation === true; //Filter sale and service locations
                    });
                }
                filteredResults.forEach((item) => {
                    this.dealerContainer.append(item.renderListView()); //Append filterd results
                });
            }
        }, 500);
        setTimeout(() => {
            this.dealerContainer.classList.remove('not-visible');
        }, 500);
    }
}
